import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=b3f1463c&scoped=true&"
import script from "./vipList.vue?vue&type=script&lang=js&"
export * from "./vipList.vue?vue&type=script&lang=js&"
import style0 from "./vipList.vue?vue&type=style&index=0&id=b3f1463c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1463c",
  null
  
)

export default component.exports